import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ade8fe12b6fa7edd237968150ee965102b from "./generated-a48d312a-ddfc-4410-ae66-20bc1701109c.json";

import a78fda572aff12c4c75ed4276e263dbb0b from "./generated-85266087-68a3-4da3-968d-35bedfcc8546.json";

import af070141d6f28a8e4aca97d93c32b66f6b from "./generated-cd7663f2-2fa9-45cb-9a3e-ca9400c78f51.json";

import a9e976c08fcd0019b342f25223603222ab from "./generated-fd79c545-5fe1-467b-bd36-48326fce135b.json";

import a7bfa71ecd4ceaf8fbcfd165216ef976db from "./generated-917d30c8-676d-450b-9713-ffd244ee6624.json";

import a8fdcac4a65db1f8a6f8e585ad60383fcb from "./generated-54e87cc5-7627-484c-93bf-95128798bedf.json";

import adba348bc7b1587e03828f61e71655bbbb from "./generated-748d0ef7-8ffb-415c-8221-d1361b42ebc2.json";

import af9467cd202d5c73a853ac6eb3eada4d2b from "./generated-754d2aea-e709-4363-b80a-fb513b3c4652.json";

import a272a149d557087e07f795592d903820ab from "./generated-409d0f81-83f3-40c5-a5d1-1e44c81db953.json";

import a654b19687b2866cfb2fb41c3ba5cf07ab from "./generated-f2e5d1d0-f57f-4aca-87ba-3d2087e6f9a5.json";

import a66f7019b0cad171ceca10badc9daaa53b from "./generated-61b3396a-30ce-4a1b-a1b5-4ec8de2b5273.json";

import ab3a2fa2ceee9cc479741a2fd3bd1ffe8b from "./generated-4939df28-6fbd-4a8c-a67c-74756007a7c5.json";

import a4e5c4d2795fec10a816243206b9886c9b from "./generated-082395a8-5047-4418-a8cf-cc4d64536cf9.json";

import a84d6c04d4cc6510c23754c0435ab445ab from "./generated-6b6f6898-e0a3-4161-b97d-9f9b81f37398.json";

import afc196280b0fe809b2204b611c7ce9f26b from "./generated-480fb286-fc0c-4a1c-8e24-df468ed02b9f.json";

import a93f708824f469e892d15e00875f1b313b from "./generated-dfdf7f5e-ba34-4074-a68a-aa8a9ded8bbc.json";

import a861bb613540fc52a3e63e4e5050ad906b from "./generated-01524b82-9355-472a-87af-a8e805d44f67.json";

import a406825bc28f53c8f80c39f731e3d7fe4b from "./generated-35ace696-6c0c-4b50-a41f-8e1033098a93.json";

import ac0adf0b0864ccaee73b6a8bfa3a3d51bb from "./generated-f40ce1d6-5842-4a99-a3f0-a91d5a75e7ac.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ade8fe12b6fa7edd237968150ee965102b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a78fda572aff12c4c75ed4276e263dbb0b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af070141d6f28a8e4aca97d93c32b66f6b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9e976c08fcd0019b342f25223603222ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a7bfa71ecd4ceaf8fbcfd165216ef976db);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a8fdcac4a65db1f8a6f8e585ad60383fcb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(adba348bc7b1587e03828f61e71655bbbb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(af9467cd202d5c73a853ac6eb3eada4d2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a272a149d557087e07f795592d903820ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a654b19687b2866cfb2fb41c3ba5cf07ab);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a66f7019b0cad171ceca10badc9daaa53b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ab3a2fa2ceee9cc479741a2fd3bd1ffe8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a4e5c4d2795fec10a816243206b9886c9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a84d6c04d4cc6510c23754c0435ab445ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(afc196280b0fe809b2204b611c7ce9f26b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a93f708824f469e892d15e00875f1b313b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a861bb613540fc52a3e63e4e5050ad906b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a406825bc28f53c8f80c39f731e3d7fe4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac0adf0b0864ccaee73b6a8bfa3a3d51bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a861bb613540fc52a3e63e4e5050ad906b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */